export const ASSIGN_CALENDAR_DATA = 'ASSIGN_CALENDAR_DATA';
